 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLHALFTITLE from '@/components/xhtml/Halftitle'
 import XHTMLFRONT from '@/components/xhtml/Front'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/Title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLCONTENTS from '@/components/xhtml/Contents'
 import XHTMLFOREWORD from '@/components/xhtml/Foreword'
 import XHTMLHALFTITLE1 from '@/components/xhtml/Halftitle1'
 import XHTMLPROLOGUE from '@/components/xhtml/Prologue'
 import XHTMLCHAPTER1 from '@/components/xhtml/Chapter1'
 import XHTMLCHAPTER2 from '@/components/xhtml/Chapter2'
 import XHTMLCHAPTER3 from '@/components/xhtml/Chapter3'
 import XHTMLCHAPTER4 from '@/components/xhtml/Chapter4'
 import XHTMLCHAPTER5 from '@/components/xhtml/Chapter5'
 import XHTMLEPILOGUE from '@/components/xhtml/Epilogue'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTMLACKNOWLEDGMENT from '@/components/xhtml/Acknowledgment'
 import XHTMLNOTES from '@/components/xhtml/Notes'
 import XHTMLESSAY from '@/components/xhtml/Essay'
 import XHTMLINDEX from '@/components/xhtml/Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/Halftitle",
 			"name" : "xhtml/Halftitle",
 			"component" : XHTMLHALFTITLE
 		},
 		{
 			"path" : "/xhtml/Front",
 			"name" : "xhtml/Front",
 			"component" : XHTMLFRONT
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/Title",
 			"name" : "xhtml/Title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/Copyright",
 			"name" : "xhtml/Copyright",
 			"component" : XHTMLCOPYRIGHT
 		},
 		{
 			"path" : "/xhtml/Contents",
 			"name" : "xhtml/Contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/Foreword",
 			"name" : "xhtml/Foreword",
 			"component" : XHTMLFOREWORD
 		},
 		{
 			"path" : "/xhtml/Halftitle1",
 			"name" : "xhtml/Halftitle1",
 			"component" : XHTMLHALFTITLE1
 		},
 		{
 			"path" : "/xhtml/Prologue",
 			"name" : "xhtml/Prologue",
 			"component" : XHTMLPROLOGUE
 		},
 		{
 			"path" : "/xhtml/Chapter1",
 			"name" : "xhtml/Chapter1",
 			"component" : XHTMLCHAPTER1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js